import { boolean, number, string, type } from "superstruct";

export const WishlistSchema = type({
    id: number(),
    title: string(),
    isDefault: boolean(),
    isPrivate: boolean(),
});

export const WishlistSchemaWithItems = type;
